<script setup lang="tsx">
import { getCSSVar } from "@zyzgroup/core-web";

const props = withDefaults(
  defineProps<{
    color?: string;
  }>(),
  {
    color: getCSSVar("--xg-blue")
  }
);

const dotStyle = { backgroundColor: props.color };
</script>

<template>
  <div class="loading-2">
    <div
      class="dot1"
      :style="dotStyle"
    ></div>
    <div
      class="dot2"
      :style="dotStyle"
    ></div>
  </div>
</template>

<style scoped>
.loading-2 {
  position: relative;
  display: block;
  width: 100%;
  height: 100%;
  text-align: center;
  animation: rotate 2s infinite linear;
}

.dot1,
.dot2 {
  width: 60%;
  height: 60%;
  display: inline-block;
  position: absolute;
  top: 0;
  border-radius: 100%;
  animation: bounce 2s infinite ease-in-out;
}

.dot2 {
  top: auto;
  bottom: 0px;
  animation-delay: -1s;
}

@keyframes rotate {
  100% {
    transform: rotate(360deg);
  }
}

@keyframes bounce {
  0%,
  100% {
    transform: scale(0);
  }
  50% {
    transform: scale(1);
  }
}
</style>
